import { arraySwap, copyJson, dateNumber } from './function'
import questionModel from '../format/convert-fields/question'
import questionTypes from '../format/convert-fields/question-types'
import jump from '../utils/jump'
import refer from '../utils/refer'

const questions = {
  number: 1,
  id () {
    return 'Q' + dateNumber() + questions.number++
  },
  make (type) {
    let data = {}
    questionTypes[type].forEach((field) => {
      data[field] = questionModel[field]
    })
    data.id = this.id()
    data.type = type
    return copyJson(data)
  },
  insert (questions, question, index = null) {
    // 默认 index
    !Number.isInteger(index) && (index = questions.length)
    questions.splice(index, 0, question)
    return question
  },
  create (questions, type, toIndex = null) {
    return this.insert(questions, this.make(type), toIndex)
  },
  up (questions, index) {
    if (index) {
      // 交换位置
      return arraySwap(questions, index, index - 1)
    }
    return false
  },
  down (questions, index) {
    if (index < questions.length - 1) {
      // 交换位置
      return arraySwap(questions, index, index + 1)
    }
    return false
  },
  remove (questions, index) {
    questions.splice(index, 1)
  },
  copy (questions, fromIndex, toIndex) {
    let newQuestion = copyJson(questions[fromIndex])
    newQuestion.id = this.id()
    questions.splice(toIndex, 0, newQuestion)
    return newQuestion
  },
  /**
   * 移除依赖这个题目的相关内容
   * @param questions
   * @param questionId
   */
  removeDependency (questions, questionId) {
    questions.forEach((question) => {
      if (question.id !== questionId) {
        // 逻辑跳转 ID清除
        if (jump.get(question).includes(questionId)) {
          jump.empty(question, questionId)
        }
        // 参考题目 ID清除
        if (refer.get(question).includes(questionId)) {
          refer.empty(question, questionId)
        }
      }
    })
  },
  /**
   * 移除全部题目中不存在的关联题目ID
   * @param questions
   */
  removeNonexistentTargetId (questions) {
    let ids = questions.map(({id}) => id)
    let remove = (array) => {
      array.forEach((value) => {
        if (value.hasOwnProperty('jumpTargetId') &&
          value.jumpTargetId !== 'end' &&
          !ids.includes(value.jumpTargetId)) {
          value.jumpTargetId = ''
        }
        if (value.hasOwnProperty('referIds')) {
          let invalidIds = _.difference(value.referIds, ids)
          if (invalidIds.length) {
            value.referIds = _.difference(value.referIds, invalidIds)
          }
        }
        if (value.options) {
          remove(value.options)
        }
      })
    }
    remove(questions)
  },
  /**
   * 替换/重置单题题目的ID, 并且全部题目中关联ID也替换
   * @param array
   * @param oldId
   * @param newId
   */
  replaceId (array, oldId, newId = this.id()) {
    array.forEach((value) => {
      // 替换题目ID
      if (value.hasOwnProperty('id') &&
        value.id === oldId) {
        value.id = newId
      }
      // 替换跳转ID
      if (value.hasOwnProperty('jumpTargetId') &&
        value.jumpTargetId === oldId) {
        value.jumpTargetId = newId
      }
      // 替换参考ID
      if (value.hasOwnProperty('referIds') &&
        value.referIds.includes(oldId)) {
        value.referIds.splice(value.referIds.indexOf(oldId), 1, newId)
      }
      // 替换选项内的跳转与参考ID
      if (value.hasOwnProperty('options')) {
        this.replaceId(value.options, oldId, newId)
      }
    })
  }
}

export default questions



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/questions.js